(function (angular) {
    angular.module('mobilezuz').config(['$stateProvider', 'PAGE_ACCESS', function ($stateProvider, PAGE_ACCESS) {
        $stateProvider.state('app.account', {
            url: '/account',
            data: {
                stateAccess: PAGE_ACCESS.LOGGED_IN,
                bodyClass: 'account',
                metaTags: {
                    title: 'Account'
                }
            },
            views: {
                '@': {
                    templateUrl: 'views/account.html',
                    controller: 'AccountCtrl as accountCtrl',
                    resolve: {
                        userData: ['User', function(User) {
                            return User.getUserSettings();
                        }]
                    }
                }
            }
        });
    }]).controller('AccountCtrl', [
        '$scope', '$rootScope', '$q', '$state', '$filter', 'mDesign', 'Config', 'User', 'Api', 'Retailer',
        'SeniorCitizenVerificationDialog', 'Util', 'PaymentsService', 'userData', 'ChooseAreaDialog',
        'CREDIT_CARD_MODES', 'SP_SERVICES', 'SP_PAYMENTS', 'CITY_TYPES', 'PHONE_TYPES', 'ORGANIZATION_TYPES', 'AccountDeletionDialogSrv',
        'GOOGLE_AUTO_COMPLETE_TYPES', 'spGoogleMapsUtil',
        function ($scope, $rootScope, $q, $state, $filter, mDesign, Config, User, Api, Retailer,
                  SeniorCitizenVerificationDialog, Util, PaymentsService, userData, ChooseAreaDialog,
                  CREDIT_CARD_MODES, SP_SERVICES, SP_PAYMENTS, CITY_TYPES, PHONE_TYPES, ORGANIZATION_TYPES, AccountDeletionDialogSrv,
                  GOOGLE_AUTO_COMPLETE_TYPES, spGoogleMapsUtil) {
            var accountCtrl = this,
                _translate = $filter('translate'),
                userLoginData = User.getUserLoginData(),
                _listeners = [],
                _originUserAddress;

            _listeners.push(function() {
                accountCtrl.userAdress = _originUserAddress;
                accountCtrl.user.addresses[0] = accountCtrl.userAdress;
                _originUserAddress = angular.copy(_originUserAddress);
            });

            $rootScope.title = 'Account';

            accountCtrl.user = userData;
            accountCtrl.isSeniorCitizen = userData.isSeniorCitizen;
            accountCtrl.title = 'Account';
            accountCtrl.userAdress = {};
            accountCtrl.customValidatedPhoneNumbers = {};

            accountCtrl.changePass = {
                email: userLoginData.email
            };
            accountCtrl.userSettings = {
                email: userLoginData.email,
                friendlyName: ''
            };
            accountCtrl.genderEnum = {male: 1, female: 2, prefer_not_to_say: 3};
            accountCtrl.logout = User.logout;
            accountCtrl.disableAddCardButton = accountCtrl.user.organization && accountCtrl.user.organization.id && accountCtrl.user.organization.organizationType !== ORGANIZATION_TYPES.NO_OBLIGO;
            accountCtrl.compiledUserAddress = Util.compiledUserAddress();
            // user.getUserSettings(true).then(function (userSettings) {
            if (accountCtrl.user.gender !== null) {
                accountCtrl.userSettings.gender = accountCtrl.user.gender.toString();
            }
            var phones = {
                1: {phoneNumber: '', typeVal: PHONE_TYPES.HOME},
                2: {phoneNumber: '', typeVal: PHONE_TYPES.WORK},
                3: {phoneNumber: '', typeVal: PHONE_TYPES.MOBILE},
                4: {phoneNumber: '', typeVal: PHONE_TYPES.VERIFY}
            };
            angular.forEach(accountCtrl.user.phones, function (phone) {
                phones[phone.typeVal] = phone;
                compileCustomValidatedPhone(phone)
            });

            accountCtrl.userSettings.phones = phones;
            //(userSettings.dateOfBirth)?  userSettings.dateOfBirth = new Date(userSettings.dateOfBirth) : new Date(1990, 1, 1);
            //_.extend(accountCtrl.userSettings, userSettings);
            accountCtrl.userSettings.dateOfBirth = new Date(accountCtrl.user.dateOfBirth);
            accountCtrl.userAdress = accountCtrl.user.addresses[0];
            _originUserAddress = angular.copy(accountCtrl.userAdress);
            accountCtrl.userSettings.friendlyName = accountCtrl.user.firstName + ' ' + accountCtrl.user.lastName;
            accountCtrl.userSettings.firstName = accountCtrl.user.firstName;
            accountCtrl.userSettings.lastName = accountCtrl.user.lastName;
            accountCtrl.userSettings.allowSendPromotions = accountCtrl.user.allowSendPromotions;
            accountCtrl.customPhoneRegExp = new RegExp(/^\(?\+?(\d[0-9\)\(-]*)$/);
            accountCtrl.phoneRegExp = new RegExp(/^\(?\+?(\d[\s,\-,(,),,,]*){7,15}$/);
            accountCtrl.customPhoneValidation = Config.retailer.customPhoneValidation && Config.retailer.customPhoneValidation.isActive;
            accountCtrl.phoneValidationSubmitted = false;
            accountCtrl.homePhone = accountCtrl.userSettings.phones[1].customPhoneNumber;
            accountCtrl.workPhone = accountCtrl.userSettings.phones[2].customPhoneNumber;
            accountCtrl.mobilePhone = accountCtrl.userSettings.phones[3].customPhoneNumber;
            accountCtrl.editPhonesMode = {};
            accountCtrl.countryNames = Util.getCountryAutocompleteOptions();

            // });
            if (accountCtrl.customPhoneValidation) {
                accountCtrl.phoneRegExp = new RegExp(/^\(?\+?(\d[0-9]*)$/);

                angular.forEach(accountCtrl.userSettings.phones, function (phone) {
                    if(Config.retailer.customPhoneValidation.areaCodes && Config.retailer.customPhoneValidation.areaCodes.length === 1) {
                        phone.areaCode = Config.retailer.customPhoneValidation.areaCodes[0]
                    }

                    if(Config.retailer.customPhoneValidation.countryCodes && Config.retailer.customPhoneValidation.countryCodes.length === 1) {
                        phone.countryCode = Config.retailer.customPhoneValidation.countryCodes[0]
                    }
                });
                accountCtrl.editPhonesMode = {
                    1: !accountCtrl.userSettings.phones[1].phoneNumber,
                    2: !accountCtrl.userSettings.phones[2].phoneNumber,
                    3: !accountCtrl.userSettings.phones[3].phoneNumber,
                }
            }
            accountCtrl.getCityAutoCompleteOptions = getCityAutoCompleteOptions;
            accountCtrl.getStreetAutoCompleteOptions = getStreetAutoCompleteOptions;
            accountCtrl.onCityChosen = onCityChosen;
            accountCtrl.addCreditCard = addCreditCard;
            accountCtrl.isSeniorCitizenChange = isSeniorCitizenChange;
            accountCtrl.toggleForm = toggleForm;
            accountCtrl.goToCouponsPage = goToCouponsPage;
            accountCtrl.isPassEquals = isPassEquals;
            accountCtrl.changePassword = changePassword;
            accountCtrl.phoneNumber = phoneNumber;
            accountCtrl.saveMembershipInfo = saveMembershipInfo;
            accountCtrl.sendTicket = sendTicket;
            accountCtrl.createNewTicket = createNewTicket;
            accountCtrl.toggleTicket = toggleTicket;
            accountCtrl.removeCard = removeCard;
            accountCtrl.removePaypalAccount = removePaypalAccount;
            accountCtrl.validateCountryCode = validateCountryCode;
            accountCtrl.validateAreaCode = validateAreaCode;
            accountCtrl.phoneEditMode = phoneEditMode;
            accountCtrl.initAccountDeletionProcess = initAccountDeletionProcess;
            accountCtrl.checkForAutocompleteAddress = checkForAutocompleteAddress;
            accountCtrl.openAutocompleteAddress = openAutocompleteAddress;
            accountCtrl.filterCountryNames = filterCountryNames;

            Retailer.getRetailerSettings().then(function(response) {
                accountCtrl.deliveryAreaMethod = response.deliveryAreaMethod;
                if (response.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.ZIP_CODE || response.deliveryAreaMethod === SP_SERVICES.DELIVERY_AREA_METHODS.CITY) {
                    getCityAutoCompleteOptions().then(function (citiesList) {
                        if (citiesList) {
                            var matching = false;
                            for (var i = 0; i < citiesList.length; i++) {
                                if (citiesList[i] === accountCtrl.userAdress.city) {
                                    matching = true;
                                }
                            }
                            if (!matching) delete accountCtrl.userAdress.city;
                        }
                    });
                }

                var settings = Util.getBranchSettings(response);
                var hasCreditCardOption = (response.checkoutPaymentMethods || []).some(function (paymentMethod) {
                    return paymentMethod.name === SP_PAYMENTS.PAYMENT_METHODS.NAMES.CREDIT_CARD;
                });

                accountCtrl.withSavedCreditCards = hasCreditCardOption && settings.creditCardMode == CREDIT_CARD_MODES.REMEMBER_CARDS;
                accountCtrl.enableFloorApartment = response.enableFloorApartment;

                accountCtrl.isSeniorCitizenActive = response.isSeniorCitizenActive;
                _checkAddressFields();
                filterCountryNames();
            });

            _getUserTickets();
            _initCreditCards();
            _initPaypalAccounts();

            function _getUserTickets(getLastData) {
                User.getUserTickets(getLastData).then(function (tickets) {
                    angular.forEach(tickets, function (ticket) {
                        ticket.normalizedDate = normalizeTime(ticket.createdDate);
                        angular.forEach(ticket.comments, function (comment) {
                            comment.normalizedDate = normalizeTime(comment.dbDate + 'Z');
                        });
                    });

                    accountCtrl.tickets = tickets;
                    accountCtrl.noTickets = tickets.length === 0;
                });
            }

            function normalizeTime(time) {
                var date = new Date(time);
                var timeOffsetInMS = $rootScope.config.retailer.timeZoneOffset * 60000;
                var localTimeOffset = new Date().getTimezoneOffset() * 60000;
                return new Date(date.setTime((date.getTime() + timeOffsetInMS) - localTimeOffset));
            }

            /*
             Fields show/hide animation
             */
            var _opened;
            function toggleForm($event) {
                $event.preventDefault();
                $event.stopPropagation();

                var $element = angular.element($event.delegateTarget || $event.currentTarget),
                    $form = $element.next();

                if (_opened) {
                    _opened.css('display', 'none');

                    _opened = $form[0] !== _opened[0] ? $form.css('display', 'block') : null;
                } else {
                    _opened = $form.css('display', 'block');
                }
            }

            function goToCouponsPage($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $state.go('app.myCoupons');
            }

            function isPassEquals() {
                if (accountCtrl.changePass.newPass && accountCtrl.changePass.newPassConfirm) {
                    return accountCtrl.changePass.newPass == accountCtrl.changePass.newPassConfirm;
                }
            }

            function _successMsg() {
                mDesign.alert(_translate('Settings was successfully changed!'));
                //accountCtrl.userAdressForm.$setPristine();
                // accountCtrl.membershipForm.$setPristine();
                User.getUserSettings(true).then(function (userSettings) {
                    accountCtrl.user = userSettings;
                    _checkAddressFields();
                    angular.forEach(userSettings.phones, function (phone) {
                        _setPhoneInputs (phone.typeVal);
                        accountCtrl.editPhonesMode[phone.typeVal] = false;
                        compileCustomValidatedPhone(phone);
                    });
                });
            }

            function changePassword() {
                var data = {
                    token: User.getUserLoginData().token,
                    newPassword: accountCtrl.changePass.newPass,
                    oldPassword: accountCtrl.changePass.pass
                };

                Api.request({
                    method: 'POST',
                    url: 'retailers/:rid/users/_changePassword',
                    data: data
                }).then(function (respond) {
                    if (respond.success) {
                        _successMsg();
                    }
                });
            }

            function phoneNumber(index) {
                var placeholders = ['Home phone', 'Other phone', 'Cell phone'];

                return placeholders[index - 1];
            }

            function saveMembershipInfo() {
                accountCtrl.userAdress.entry = _getEntryValue(accountCtrl.userAdress.entry)
                var phonesCopy = angular.copy(accountCtrl.userSettings.phones)
                if(accountCtrl.customPhoneValidation) {
                    accountCtrl.editPhonesMode = {
                        1: !accountCtrl.userSettings.phones[1].phoneNumber,
                        2: !accountCtrl.userSettings.phones[2].phoneNumber,
                        3: !accountCtrl.userSettings.phones[3].phoneNumber,
                    }
                    accountCtrl.homePhone = phonesCopy[1] ? phonesCopy[1].customPhoneNumber : '';
                    accountCtrl.workPhone =  phonesCopy[2] ? phonesCopy[2].customPhoneNumber : '';
                    accountCtrl.mobilePhone =  phonesCopy[3] ? phonesCopy[3].customPhoneNumber : '';
                    var phoneCopyArr = Object.values(phonesCopy) || [];

                    phoneCopyArr.forEach(function (phone) {
                        if(accountCtrl.userSettings.phones && accountCtrl.userSettings.phones[phone.typeVal] && (accountCtrl.userSettings.phones[phone.typeVal].phoneNumber || accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber)) {
                            accountCtrl.userSettings.phones[phone.typeVal].phoneNumber = accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber ? accountCtrl.userSettings.phones[phone.typeVal].areaCode + accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber : '';
                            accountCtrl.userSettings.phones[phone.typeVal].customValidated = (accountCtrl.userSettings.phones[phone.typeVal].customPhoneNumber && accountCtrl.customPhoneValidation);
                            compileCustomValidatedPhone(accountCtrl.userSettings.phones[phone.typeVal]);
                        }
                        _setPhoneInputs(phone.typeVal);
                    });
                    accountCtrl.userSettings.phones = phones;
                }
                Util.cleanUserAddressObject(accountCtrl.userAdress);

                var sendingData = {
                    firstName: accountCtrl.userSettings.firstName,
                    lastName: accountCtrl.userSettings.lastName,
                    birthDate: accountCtrl.userSettings.dateOfBirth,
                    allowSendPromotions: accountCtrl.userSettings.allowSendPromotions,
                    gender: parseFloat(accountCtrl.userSettings.gender),
                    phones: accountCtrl.userSettings.phones,
                    addresses: [accountCtrl.userAdress]
                };
                // can only unselect is senior citizen through here
                if (!accountCtrl.isSeniorCitizen && accountCtrl.user.isSeniorCitizen) {
                    sendingData.isSeniorCitizen = false;
                }
                accountCtrl.phoneValidationSubmitted = true;
                Api.request({
                    method: 'PATCH',
                    url: 'retailers/:rid/users/:uid',
                    data: sendingData
                }).then(function () {
                    _originUserAddress = angular.copy(accountCtrl.userAdress);
                    _successMsg();
                }).catch(function () {
                    User.getUserSettings(true).then(function (userSettings) {
                        accountCtrl.user = userSettings;
                        angular.forEach(userSettings.phones, function (phone) {
                            _setPhoneInputs (phone.typeVal);
                            accountCtrl.editPhonesMode[phone.typeVal] = false;
                            compileCustomValidatedPhone(phone);
                        });
                    });
                });
            }

            function phoneEditMode(phoneType, editMode) {
                if (accountCtrl.customPhoneValidation) {
                    if (accountCtrl.editPhonesMode[phoneType] && editMode) {
                        return;
                    }
                    accountCtrl.customValidatedPhoneNumbers[phoneType] = '';
                    accountCtrl.editPhonesMode[phoneType] = editMode;
                    if (editMode) {
                        accountCtrl.userSettings.phones[phoneType].customPhoneNumber = accountCtrl.userSettings.phones[phoneType].customPhoneNumber || '';
                        setTimeout(function () {
                            var newInputField = document.getElementById('phone-input-' + phoneType);
                            if(newInputField) {
                                newInputField.focus()
                            }
                        }, 0);
                        angular.forEach(accountCtrl.user.phones, function (phone) {
                            if(phone.typeVal !== phoneType) {
                                _setPhoneInputs (phone.typeVal);
                                accountCtrl.editPhonesMode[phone.typeVal] = false;
                                compileCustomValidatedPhone(phone);
                            }
                        })
                    } else {
                        _setPhoneInputs(phoneType);
                        compileCustomValidatedPhone(accountCtrl.userSettings.phones[phoneType])
                    }
                }
            }

            function compileCustomValidatedPhone(phone) {
                phone.customValidated = (phone.customValidated && phone.customPhoneNumber)
                if(phone.customValidated) {
                    if(phone.phoneNumber && phone.customValidated) {
                        accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = [
                            phone.countryCode ? phone.countryCode.toString() : '',
                            phone.areaCode ? phone.areaCode.toString() : '',
                            phone.customPhoneNumber ? phone.customPhoneNumber.toString() : ''
                        ].join('');
                    } else if (phone.phoneNumber && phone.customPhoneNumber !== '' && !phone.customValidated) {
                        accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = phone.phoneNumber
                    } else {
                        accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = '';
                    }

                } else {
                    accountCtrl.customValidatedPhoneNumbers[phone.typeVal] = phone.phoneNumber;
                }
            }

            function _setPhoneInputs (phoneType) {
                switch (phoneType) {
                    case 1 : {
                        accountCtrl.userSettings.phones[1].customPhoneNumber = accountCtrl.homePhone;
                        break;
                    }
                    case 2 : {
                        accountCtrl.userSettings.phones[2].customPhoneNumber = accountCtrl.workPhone;
                        break;
                    }
                    case 3 : {
                        accountCtrl.userSettings.phones[3].customPhoneNumber = accountCtrl.mobilePhone;
                        break;
                    }
                    default:
                        return;
                }
            }

            function validateCountryCode (countryCode, phoneNumber) {
                if(phoneNumber && accountCtrl.phoneValidationSubmitted) {
                    return Config.retailer.customPhoneValidation.countryCodes.some(function (code) {
                        return code == countryCode;
                    });
                }
                return true;
            }


            function validateAreaCode (areaCode, phoneNumber) {
                if(phoneNumber && accountCtrl.phoneValidationSubmitted) {
                    return Config.retailer.customPhoneValidation.areaCodes.some(function (code) {
                      return code == areaCode;
                    });
                }
                return true;
            }

            function getCityAutoCompleteOptions() {
                if (!accountCtrl.userAdress.city) {
                    return $q.resolve();
                }

                return Api.request({
                    method: 'GET',
                    url: '/v2/addresses/cities',
                    params: {
                        term: accountCtrl.userAdress.city,
                        size: 5
                    }
                }).then(function (data) {
                    accountCtrl.citiesObject = {};
                    return data.cities.map(function (city) {
                        accountCtrl.citiesObject[city.name] = city;
                        return city.name;
                    });
                });
            }

            function onCityChosen() {
                accountCtrl.streetIsRequire = (accountCtrl.citiesObject[accountCtrl.userAdress.city] && accountCtrl.citiesObject[accountCtrl.userAdress.city].type === CITY_TYPES.MULTIPLE_ZIP_CODES);
            }

            //set "None" value as null
            function _getEntryValue(entry) {
                if (entry === _translate($rootScope.HOUSE_ENTRIES[0])) {
                    return null;
                }
                return entry;
            }

            function getStreetAutoCompleteOptions() {
                if (!accountCtrl.userAdress.street) return;
                var cityId = accountCtrl.citiesObject[accountCtrl.userAdress.city] && accountCtrl.citiesObject[accountCtrl.userAdress.city].id;

                if (!cityId) {
                    return;
                }

                return Api.request({
                    method: 'GET',
                    url: '/v2/addresses/streets',
                    params: {
                        term: accountCtrl.userAdress.street,
                        cityId: cityId,
                        size: 4
                    }
                }).then(function (data) {
                    return data.streets.map(function (street) {
                        return street.name;
                    });
                });
            }

            /* Contact Us*/
            function sendTicket() {

                if (angular.isUndefined($rootScope.config.getBranchArea())){
                    return ChooseAreaDialog.show(false);
                }

                accountCtrl.details = {};
                accountCtrl.details.branchId = Config.branch.id;
                accountCtrl.details.userId = accountCtrl.user.id;
                accountCtrl.details.name = accountCtrl.user.firstName + ' ' + accountCtrl.user.lastName;
                accountCtrl.details.email = accountCtrl.user.email;
                accountCtrl.details.phone = accountCtrl.user.phones && accountCtrl.user.phones.length ? accountCtrl.user.phones[0].phoneNumber : '';
                accountCtrl.details.message = accountCtrl.contactUs;

                Api.request({
                    method: 'POST',
                    url: '/retailers/:rid/contactUs',
                    data: accountCtrl.details
                }).then(function () {
                    //$scope.isSent = true;
                    $rootScope.$emit('contactUs', accountCtrl.details.email, accountCtrl.details.name);
                    accountCtrl.contactUs = '';
                    _getUserTickets(true);

                }).catch(function (res) {
                    // Util.setServerErrorToForm(form, formElement, res);
                });
            }

            /* Tickets */
            function createNewTicket(selectedTicket) {
                mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: false,
                    templateUrl: 'views/templates/add-ticket.html',
                    controller: ['$scope', function ($scope) {
                        $scope.createUserTicketComment = createUserTicketComment;
                        $scope.selectedTicket = selectedTicket;
                        $scope.cancel = hide;
                        $scope.attachments = [];

                        function hide() {
                            mDesign.hide();
                        }

                        function createUserTicketComment() {
                            mDesign.hide();

                            if (!$scope.userTicketComment.comment) return;
                            $scope.userTicketComment.ticketId = $scope.selectedTicket.id;

                            User.uploadTicketAttachment($scope.userTicketComment.attachment).then(function (data) {
                                if (data) {
                                    $scope.userTicketComment.attachments = [data.url.fullUrl];
                                }
                                return User.createUserTicketComment($scope.userTicketComment);
                            }).then(function (data) {
                                if (!data.success) {
                                    return;
                                }

                                $scope.userTicketComment.createdDate = new Date();
                                $scope.userTicketComment.commentById = accountCtrl.user.id;
                                $scope.userTicketComment.local = true;
                                $scope.userTicketComment.normalizedDate = $scope.userTicketComment.createdDate;
                                $scope.selectedTicket.comments.push($scope.userTicketComment);
                                $scope.userTicketComment = {};
                                if ($scope.attachments.length > 0) {
                                    $scope.selectedTicket.attachments = $scope.attachments;
                                    $scope.attachments = [];
                                }
                            });
                        }
                    }]
                });
            }

            function toggleTicket(ticket) {
                angular.forEach(accountCtrl.tickets, function (ticketItem) {
                    if (ticket == ticketItem) return;
                    ticketItem.ticketInfo = false;
                });

                ticket.ticketInfo = !ticket.ticketInfo;
            }

            /* Credit Card */
            function _initCreditCards() {
                accountCtrl.creditCards = accountCtrl.user.creditCards || [];
                var defaultCard = accountCtrl.user.creditCards ? angular.filterCollection(accountCtrl.user.creditCards, function (x) {
                    return x.isDefault;
                }) : null;
                accountCtrl.creditCard = defaultCard && defaultCard.length ? defaultCard[0] : (accountCtrl.user.creditCards && accountCtrl.user.creditCards.length ? accountCtrl.user.creditCards[0] : null);
            }

            /* PayPal */
            function _initPaypalAccounts() {
                accountCtrl.paypalAccounts = accountCtrl.user.paypalAccounts || [];
                var defaultPaypalAccount = accountCtrl.user.paypalAccounts ? angular.filterCollection(accountCtrl.user.paypalAccounts, function (x) {
                    return x.isDefault;
                }) : null;
                accountCtrl.paypalAccount = defaultPaypalAccount && defaultPaypalAccount.length ? defaultPaypalAccount[0]
                    : (accountCtrl.user.paypalAccount && accountCtrl.user.paypalAccount.length ? accountCtrl.user.paypalAccount[0] : null);
            }

            function removeCard(selectedCard) {
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: false,
                    templateUrl: 'views/templates/remove-credit-card.html',
                    controller: ['$scope', function ($scope) {
                        $scope.selectedCard = selectedCard;
                        $scope.delete = deleteCardInfo;
                        $scope.cancel = cancel;

                        function cancel() {
                            mDesign.hide();
                        }

                        function deleteCardInfo() {
                            mDesign.hide();

                            return Api.request({
                                method: 'DELETE',
                                url: '/retailers/:rid/users/:uid/removecard',
                                data: {
                                    cardId: $scope.selectedCard.id
                                },
                                headers: {
                                    'content-type': 'application/json'
                                }
                            }).then(function () {
                                setTimeout(function() {
                                    User.getUserSettings(true)
                                        .then(function (data) {
                                            accountCtrl.user = data;
                                            _initCreditCards();
                                        })
                                }, 1000);
                                $scope.$applyAsync();
                            });
                        }
                    }]
                });
            }

            function addCreditCard() {
                if (Config.retailer.settings.useDeliveryAddressAsBilling && accountCtrl.compiledUserAddress) {
                    return mDesign.dialog({
                        templateUrl: 'views/templates/use-delivery-address-as-billing.html',
                        controller: ['$scope', function ($dialogScope) {
                            var dialogCtrl = this;
                            dialogCtrl.sendUserAddress = false;
                            var userAddress = accountCtrl.user.addresses && accountCtrl.user.addresses[0];
                            var userCountryName = userAddress && userAddress.country;
                            if (userCountryName) {
                                userAddress.countryCode = Util.getCountryCode(userCountryName);
                            }
                            dialogCtrl.compiledUserAddress = Util.compiledUserAddress(_originUserAddress);
                            dialogCtrl.cancel = cancel;
                            $dialogScope.continue = function () {
                                mDesign.hide();
                                return PaymentsService.addCreditCard({
                                    sendUserAddress: dialogCtrl.sendUserAddress,
                                    address: userAddress.text1 ? userAddress.text1 : userAddress.text2 ? userAddress.text2 : '',
                                    city: userAddress.city ? userAddress.city : '',
                                    country: userAddress.country ? userAddress.country : '',
                                    countryCode: userAddress.countryCode ? userAddress.countryCode : '',
                                }).then(function () {
                                    setTimeout(function () {
                                        User.getUserSettings(true)
                                            .then(function (data) {
                                                accountCtrl.user = data;
                                                _initCreditCards();
                                            })
                                    }, 1000);
                                });
                            };

                            function cancel() {
                                mDesign.hide();
                            }
                        }],
                        controllerAs: 'dialogCtrl',
                        styleClass: 'clear-cart-popup'
                    });
                } else {
                    return PaymentsService.addCreditCard().then(function() {
                        setTimeout(function() {
                            User.getUserSettings(true)
                                .then(function (data) {
                                    accountCtrl.user = data;
                                    _initCreditCards();
                                })
                        }, 1000);
                    });
                }
            }

            function removePaypalAccount(selected) {
                return mDesign.dialog({
                    focusOnOpen: false,
                    clickOutsideToClose: false,
                    templateUrl: 'views/templates/remove-paypal-account.html',
                    controller: ['$scope', function ($scope) {
                        $scope.selectedAccount = selected;
                        $scope.delete = deletePaypalAccount;
                        $scope.cancel = cancel;

                        function cancel() {
                            mDesign.hide();
                        }

                        function deletePaypalAccount() {
                            mDesign.hide();

                            return Api.request({
                                method: 'DELETE',
                                url: '/retailers/:rid/users/:uid/removepaypalaccount',
                                data: {
                                    accountId: $scope.selectedAccount.id
                                },
                                headers: {
                                    'content-type': 'application/json'
                                }
                            }).then(function () {
                                return User.getUserSettings(true);
                            }).then(function (data) {
                                accountCtrl.user = data;
                                _initPaypalAccounts();
                                $scope.$applyAsync();
                            });
                        }
                    }]
                });
            }

            function isSeniorCitizenChange() {
                if (!accountCtrl.isSeniorCitizen || accountCtrl.user.isSeniorCitizen) {
                    return;
                }

                return SeniorCitizenVerificationDialog.show().then(function() {
                    return User.getUserSettings();
                }).then(function(userData) {
                    accountCtrl.user = userData;
                    accountCtrl.isSeniorCitizen = userData.isSeniorCitizen;
                });
            }

            function initAccountDeletionProcess() {
                AccountDeletionDialogSrv.show();
            }

            function _checkAddressFields() {
                if (accountCtrl.user.addresses && accountCtrl.user.addresses.length) {
                    accountCtrl.user.hasAddressDetails = Util.checkAddressFields(accountCtrl.user.addresses[0]);
                }
            }

            function checkForAutocompleteAddress(evt) {
                if ((evt.target.disabled || angular.element(evt.target).attr('disabled') === 'disabled' || evt.target.name === 'zip') &&
                    Config.retailer.settings.autocompleteAddressField) {
                    if(evt.target.name === 'zip') {
                        mDesign.alert(_translate('zipcode error'));
                    } else {
                        if(!Config.retailer.settings.activeZipProvider.isLockedAddress) {
                            mDesign.alert(_translate('not editable error'));
                        } else if (Config.retailer.settings.activeZipProvider.isLockedAddress) {
                            if (!accountCtrl.userAdress.city) {
                                mDesign.alert(_translate('not_editable_locked_empty error'));
                            } else {
                                mDesign.alert(_translate('not_editable_locked error'));
                            }
                        }
                    }
                }
            }

            function filterCountryNames() {
                accountCtrl.countryNames = Util.getCountryAutocompleteOptions().filter(function (country) {
                    return country.toLowerCase().indexOf(accountCtrl.userAdress.country.toLowerCase()) !== -1;
                });
            }

            function openAutocompleteAddress(evt) {
                evt.preventDefault();
                return mDesign.dialog({
                    templateUrl: 'views/templates/choose-address.html',
                    controller: ['$scope', function ($dialogScope) {
                        var dialogCtrl = this;
                        Util.getAddressByZipCode(accountCtrl.userAdress.zipCode).then(function (result) {
                            dialogCtrl.addresses = result;
                            dialogCtrl.errorMessage = !result || !result.length;
                        })
                        $dialogScope.continue = function () {
                            if (dialogCtrl.addresses && ((dialogCtrl.addresses.length && !dialogCtrl.address) || dialogCtrl.errorMessage)) {
                                return;
                            }

                            delete dialogCtrl.address.description;
                            accountCtrl.userAdress = Object.assign(accountCtrl.userAdress, dialogCtrl.address);
                            _checkAddressFields();
                            mDesign.hide();
                        };
                        $dialogScope.cancel = function () {
                            mDesign.hide();
                        };
                    }],
                    controllerAs: 'dialogCtrl',
                    styleClass: 'choose-address',
                    ariaLabelledby: 'choose_address_dialog_title',
                })
            }

            Util.destroyListeners($scope, _listeners);
        }]);
})(angular);
